import { toast } from 'react-toastify';

import api from '../../services/api';
import {
  DEL_SHEET_FAIL,
  DEL_SHEET_REQ,
  DEL_SHEET_SUCCESS,
  GET_SHEET_SETTINGS_FAIL,
  GET_SHEET_SETTINGS_REQ,
  GET_SHEET_SETTINGS_SUCCESS,
  SAVE_SHEET_SETTINGS_FAIL,
  SAVE_SHEET_SETTINGS_REQ,
  SAVE_SHEET_SETTINGS_SUCCESS,
} from '../constants/settings';

export const getSheetSettings =
  (curpage, type) => async (dispatch, getState) => {
    try {
      dispatch({ type: GET_SHEET_SETTINGS_REQ });
      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.gmBackendToken}`,
        },
      };

      const { data } = await api.get(
        `/api/sheets?page=${curpage}&type=${type}`,
        config
      );

      dispatch({
        type: GET_SHEET_SETTINGS_SUCCESS,
        payload: data?.body,
      });
    } catch (error) {
      dispatch({
        type: GET_SHEET_SETTINGS_FAIL,
        payload:
          error.response && error.response.data.error
            ? error.response.data.error
            : error.message,
      });

      const message =
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message;

      if (message === 'NotAuthorized') {
        toast.error('Please login from extension and the reload this page');
        localStorage.removeItem('_gm_usr');
        window.location.reload();
      } else if(error.response.status === 401){
        toast.error("Autorization failed, please re-login to the extension")
      } else {
        setTimeout(() => {
          toast.error(message);
        }, 1000);
      }
    }
  };

export const addSheetSettings = (body) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SAVE_SHEET_SETTINGS_REQ,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.gmBackendToken}`,
      },
    };

    const { data } = await api.post(`/api/sheets`, body, config);
    if (data?.success) {
      setTimeout(() => {
        toast.success('Spreadsheet has added successfully');
      }, 1000);
    }
    dispatch({
      type: SAVE_SHEET_SETTINGS_SUCCESS,
      payload: data?.body,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.error
        ? error.response.data.error
        : error.message;

    dispatch({
      type: SAVE_SHEET_SETTINGS_FAIL,
      payload: message,
    });
    if (message === 'NotAuthorized') {
      toast.error('Please login from extension and the reload this page');
      localStorage.removeItem('_gm_usr');
      window.location.reload();
    } else if(error.response.status === 401){
			toast.error("Autorization failed, please re-login to the extension")
		} else {
      setTimeout(() => {
        toast.error(message);
      }, 1000);
    }
  }
};

export const delSheetSettings = (id, type) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DEL_SHEET_REQ,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.gmBackendToken}`,
      },
    };

    const { data } = await api.delete(`/api/sheets/${id}`, config);
    if (data?.success) {
      setTimeout(() => {
        toast.success('Spreadsheet has deleted successfully');
      }, 1000);
    }
    dispatch({
      type: DEL_SHEET_SUCCESS,
      payload: { id, type },
    });
  } catch (error) {
    const message =
      error.response && error.response.data.error
        ? error.response.data.error
        : error.message;

    dispatch({
      type: DEL_SHEET_FAIL,
      payload: message,
    });
    if (message === 'NotAuthorized') {
      toast.error('Please login from extension and the reload this page');
      localStorage.removeItem('_gm_usr');
      window.location.reload();
    } else if(error.response.status === 401){
			toast.error("Autorization failed, please re-login to the extension")
		} else {
      setTimeout(() => {
        toast.error(message);
      }, 1000);
    }
  }
};

export const getAllSheetSettings = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_SHEET_SETTINGS_REQ });
    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.gmBackendToken}`,
      },
    };

    const { data } = await api.get(`/api/sheets/all`, config);

    const allSheets = [{ data: data?.body, metadata: [{}] }];

    dispatch({
      type: GET_SHEET_SETTINGS_SUCCESS,
      payload: allSheets,
    });
  } catch (error) {
    dispatch({
      type: GET_SHEET_SETTINGS_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message,
    });

    const message =
      error.response && error.response.data.error
        ? error.response.data.error
        : error.message;

    if (message === 'NotAuthorized') {
      toast.error('Please login from extension and the reload this page');
      localStorage.removeItem('_gm_usr');
      window.location.reload();
    } else if(error.response.status === 401){
			toast.error("Autorization failed, please re-login to the extension")
		} else {
      setTimeout(() => {
        toast.error(message);
      }, 1000);
    }
  }
};
